import { render } from "./PartnerSlider.vue?vue&type=template&id=1fd0252c"
import script from "./PartnerSlider.vue?vue&type=script&lang=js"
export * from "./PartnerSlider.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/jwbpinellas/wp-content/themes/jwb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__